import { Component, EventEmitter, Output, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.css']
})
export class SearchBarComponent {

  @Input() idVal: string = '';
  @Input() bookType: string = '';
  @Input() productId: string = '';
  @Input() workingTitle: string = '';
  @Input() dropdownListProductType: any = [];
  @Input() dropdownSettingsProductType: any = [];
  @Input() dropdownListBookType: any = [];
  @Input() dropdownSettingsBookType: any = [];
  searchParams: any = [];
  @Output() searchProductEvent: EventEmitter<any> = new EventEmitter;



  searchProduct() {

    this.searchParams = {

      'idVal': this.idVal,
      'bookType': this.bookType,
      'productId': this.productId,
      'workingTitle': this.workingTitle,

    }

    this.searchProductEvent.emit(this.searchParams);
  }

}
